import {isNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

import {AuditCategoryOfStructure} from '../../../types/AuditCategoryOfStructure';
import {AuditParamType} from '../types/AuditParamType';
import {getParamFromCategory} from './getParamFromCategory';

/**
 * Whether the category offers `damageTypeValue` as one of its selectable damage types.
 *
 * A nullish or empty type counts as supported: there is no damage type to lose, so moving a
 * record to this part takes nothing away from it and the inspector needs no warning.
 */
export const supportsDamageType = (
  category: AuditCategoryOfStructure,
  damageTypeValue: string | Nullish
): boolean => {
  if (isNilOrEmpty(damageTypeValue)) {
    return true;
  }

  const typeParam = getParamFromCategory(category, AuditParamType.SELECTABLE_BUTTON);

  return Boolean(typeParam?.values.some((option) => option.value === damageTypeValue));
};
